import {
  Button,
  Drawer,
  Popconfirm,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import Search from "antd/es/input/Search";
import React, { useState } from "react";
import useSWR from "swr";
import { fetcherhn } from "../../services/fectcher";
import { WarningOutlined } from "@ant-design/icons";
import { openNotification } from "../../common/elements/myNotification";
import { deleteGrievanceTemplate } from "../../api/CareEventSCPApi";
import { GrievanceTemplateAdd } from "./GrievanceTemplateAdd";
import { handleToggle } from "../../common/elements/toggleSeeMore";
import { FaEdit, FaMobileAlt, FaRegTrashAlt } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import SendEmail from "../../common/elements/SendEmail";
import { useMyContext } from "../../common/elements/myContext";

export const GrievanceTemplate = (props) => {
  const intialReqState = {
    key: "",
    guid: "",
    mbi: props.mbiid,
    callerName: "",
    callerContact: "",
    callerMessage: "",
    createdBy: sessionStorage.getItem("userName"),
    modifiedBy: "",
  };

  const { formatPhoneNumber } = useMyContext();

  const [editRecord, setEditRecord] = useState(intialReqState);
  const [query, setQuery] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, mutate, isLoading } = useSWR(
    `GetGriveanceTemplate?id=${props.mbiid}`,
    fetcherhn
  );

  const handleCancel = (e) => {
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const handleModalClose = (e) => {
    setEditRecord(intialReqState);
    setMail(false);
  };

  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(intialReqState);
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };
  const handleDelete = async (record) => {
    const body = { ...record, modifiedBy: sessionStorage.getItem("userName") };
    const deleteResult = await deleteGrievanceTemplate(body);
    if (deleteResult.status) {
      mutate();
      openNotification(
        "success",
        "Deleted",
        "Grievance Template Deleted Successfully!"
      );
    }
    setEditRecord(intialReqState);
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const [mail, setMail] = useState(false);

  const sendDatatoEmail = (record) => {
    setMail(true);
    setEditRecord(record);
  };

  const columns = [
    {
      key: 1,
      title: "Caller Name",
      dataIndex: "callerName",
      width: 210,

      render: (_, { callerName, callerContact }) => (
        <>
          <div>{callerName}</div>
          {callerContact ? (
            <div
              style={{
                fontSize: "0.9rem",
                color: "var(--bs-gray-600)",
                marginBottom: "0.3rem",
                marginTop: "0.3rem",
                overflowWrap: "break-word",
              }}
            >
              <FaMobileAlt
                size={20}
                style={{
                  color: "var(--bs-gray-500)",
                  marginRight: "0.5rem",
                  marginTop: "-2px",
                }}
              />
              <a href={`tel:${formatPhoneNumber(callerContact)}`}>
                {formatPhoneNumber(callerContact)}
              </a>
            </div>
          ) : (
            ""
          )}
        </>
      ),
    },
    // {
    //   key: 2,
    //   title: "Caller Contact #",
    //   dataIndex: "callerContact",
    //   width: 130,
    // },
    {
      key: 3,
      title: "Message",
      dataIndex: "callerMessage",
      render: (text, record) => {
        const isExpanded = expandedRows.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: 4,
      title: "Created By",
      dataIndex: "createdBy",
      width: 150,
      render: (createdBy) => <div>{createdBy.split("@")[0]}</div>,
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 110,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Send Email">
              <FiSend
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => sendDatatoEmail(record)}
                color="green"
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data.filter((item) => {
        return [
          "callerName",
          "callerContact",
          "callerMessage",
          "createdBy",
        ].some((key) =>
          (item[key]?.toString()?.toLowerCase() ?? "").includes(
            query?.toLowerCase() ?? ""
          )
        );
      })
    : data;

  if (isLoading) {
    return <Skeleton active={isLoading} />;
  }

  return (
    <div>
      <div className="tw-flex tw-justify-between ">
        <p
          className="pt-3"
          style={{
            color: "#D2691E",
            fontWeight: "600",
          }}
        >
          Grievance Template
        </p>

        <div className="tw-flex tw-justify-end  tw-mt-3 ">
          <Space>
            <Search
              className=" tw-mb-4"
              size="middle"
              placeholder="Search"
              onChange={(e) => setQuery(e.target.value)}
              allowClear
            />
            <Button
              type="primary"
              onClick={() => setIsModalOpen(true)}
              className="tw-mb-4 "
            >
              Add
            </Button>
          </Space>
        </div>
      </div>
      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title={"Add/Update Grievance Template"}
          onClose={handleCancel}
          width={900}
        >
          <GrievanceTemplateAdd callback={handleOk} editRecord={editRecord} />
        </Drawer>
      )}
      <Table
        bordered
        size="middle"
        dataSource={finalResult}
        columns={columns}
      />

      {mail && (
        <SendEmail
          open={mail}
          close={handleModalClose}
          editRecord={editRecord}
          modalTitle={"Grievance Template"}
          patientName={props?.patient?.label}
        />
      )}

      {/* {summary && (
        <GetModalDetails
          keyProp={selectedKey}
          mbi={selectedRecord?.mbi}
          isVisible={summary}
          handleOk={() => setSummary(false)}
          handleCancel={() => setSummary(false)}
          modalTitle={"Grievance Template"}
          apiNode={"GetGriveanceTemplate"}
          patientName={props?.patient?.label}
        />
      )} */}
    </div>
  );
};
